import Api from '../api';

let uri = '/api/ed/categoria';

export const getCategorias = (data) => {
    return Api.getInstance()
      .executeQuery(`${uri}/list`, data, { cache: true })
      .then((resp) => resp.data)
      .catch((error) => console.log(error));
}

export const mergeCategoria = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const deleteCategoria = (data)  => {
    return Api.getInstance().executeDeleteQuery(uri, {data: data})
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getSegmentosCategoria = (data) => {
    return Api.getInstance().executeQuery(`${uri}/segmento`, data)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

export const adminCategoriaSegmento = (data) => {
    return Api.getInstance().executeQuery(`${uri}/admin/segmento`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}



